module.exports = __webpack_public_path__ + "img/logo.6c1475e8.png";